import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { shownDefaultFalse3hpz4awymyomc as shownDefaultFalse } from '../../../utils/utils.mjs';
import { get_dp28ag147e4p5cz as get_dp } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  title1ahgushtajx2d as title,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import { space2ppi73m2qk1br as space } from '../space.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { take9j4462mea726 as take } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function previewInformation(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(true);
  shownDefaultFalse(view, ($this$shownDefaultFalse) => $this$shownDefaultFalse.baj(_this__u8e3s4.egi_1));
  view.dba(get_dp(0));
  title(view, ($this$title) => {
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
    reactiveScope($this$title, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.baj(_this__u8e3s4.jfy()).d7b_1;
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    return Unit_instance;
  });
  space(view, get_AppDimensions().yg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(get_dp(0));
  space(view_0, get_AppDimensions().wg1_1);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_0(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var description = $this$reactiveScope.baj(_this__u8e3s4.jfy()).e7b_1;
    var tmp$ret$2 = description.length > 200 ? take(description, 200) + '...' : description;
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  view_0.fbb(p_1, view_1);
  space(view_0, get_AppDimensions().wg1_1);
  view.fbb(p_0, view_0);
  writer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
//region block: exports
export {
  previewInformation as previewInformation37nza2t378ikc,
};
//endregion

//# sourceMappingURL=previewInformation.mjs.map
